module.exports = __webpack_public_path__ + "img/markqueue.f7af4f71.webp";